<template>
    <div>
        <SubNavigation :navigation="navigation" />

        <FlashNotification />

        <router-view></router-view>
    </div>
</template>

<script>
import FlashNotification from '../components/FlashNotification.vue';
import SubNavigation from '../components/SubNavigation.vue';

export default {
    components: {
        FlashNotification,
        SubNavigation,
    },

    data: function() {
        return {
            navigation: [
                {
                    label: 'Statements',
                    name: 'accounts',
                    visible: true,
                },
                {
                    label: 'Transactions',
                    name: 'transactions',
                    visible: this.$meta.features.owners.transactions,
                },
                {
                    label: 'Invoices',
                    name: 'invoices',
                    visible: this.$meta.features.owners.invoices,
                },
            ],
        };
    },
};
</script>
